/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step1_AiInputs */

const en_dr_step1_ai = /** @type {(inputs: Dr_Step1_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Challenger: "what happens if this never gets built?"`)
};

const id_dr_step1_ai = /** @type {(inputs: Dr_Step1_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penantang: "apa yang terjadi kalau ini tidak dibangun?"`)
};

/**
* | output |
* | --- |
* | "Challenger: \"what happens if this never gets built?\"" |
*
* @param {Dr_Step1_AiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step1_ai = /** @type {((inputs?: Dr_Step1_AiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step1_AiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step1_ai(inputs)
	return en_dr_step1_ai(inputs)
});